import React, { useDebugValue, useEffect, useState } from "react";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { fetchGenders, selectGender } from "../../redux/actions/genderActions";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { fetchLanguage } from "../../redux/actions/LanguageAction";

const UpdateCandidateProfile = () => {
  const sessionId = localStorage.getItem("sessionId");
  const userUID = localStorage.getItem("userUID"); 

  
  // ...............................Gender DDL.......................................

  const [genderValue, setGenderValue] = useState(null);
  const dispatch = useDispatch();
  const { genderOptions, selectedGender } = useSelector(
    (state) => state.gender
  );
  useEffect(() => {
    dispatch(fetchGenders());
  }, [dispatch]);
  const handleGenderSelect = (selectedOption) => {
    if (selectedOption) {
      setGenderValue(selectedOption.value);
      // dispatch(selectGender(selectedOption.value));
    }
  };
  // ...............................Gender DDL.......................................
  
 // ...............................language DDL.......................................
 
  const [langValue, setLangValue] = useState("");
  const { LanguageList, selectedLanguageId } = useSelector(
    (state) => state.language
  );
  // console.log("language", LanguageList);

  useEffect(() => {
    dispatch(fetchLanguage());
  }, [dispatch]);

  const handleLanguageSelect = (selectedOption) => {

    setLangValue(selectedOption.value);

  };
  // ...............................language DDL.......................................

  // ...............................City DDL.......................................
  const [cityId, setcityId] = useState("");
  const { cityList, selectedcityId } = useSelector((state) => state.cities);
  useEffect(() => {
    dispatch(fetchCityData());
  }, [dispatch]);
  const handleCitySelect = (selectedOption) => {
    if (selectedOption) {
      {
      }
      setcityId(selectedOption.value); 
    }
  };

  // ...............................City DDL.......................................

  // ...............................PROFILE Start.......................................
  const [displays, setDisplays] = useState(false);
  const [cityValue, setCitValue] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [profileImageview, setProfileImageview] = useState("");

  const handleProfileImageChange = (event) => {
    const selectedFile = event.target.files[0];
    setProfileImage(selectedFile);
    setProfileImageview(URL.createObjectURL(selectedFile));
  };
  const Profile = async (e) => {
    e.preventDefault();
    try {
      setDisplays(true);
      console.log("Session ID:", sessionId);
      if (
        langValue &&
        genderValue &&
        cityId &&
        startDate &&
        profileImage !== ""
      ) {
        const formData = new FormData();
        formData.append("LangId", langValue);
        formData.append("GenderId", genderValue);
        formData.append("CityId", cityId);
        formData.append(
          "Dob",
          startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD")
        );
        formData.append("ProfileImage", profileImage);
        formData.append("SessionId", sessionId);
        const res = await axios.post(
          "/Account/UpdateCandidateProfile",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log("get data", res);
        toast.success(res.data.message);
        setLangValue("");
        setGenderValue("");
        setCitValue("");
        setStartDate("");
        setProfileImage("");
        setProfileImageview("");
        setDisplays(false);
      } else {
        toast.error("please enter required fields!");
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message);
      } else {
        toast.error(error.response?.data?.message || "An error occurred");
      }
    }
  };
  // ...............................PROFILE End.......................................

  // ...............................Get PROFILE Start.......................................
  const [profileData, setProfileData] = useState("");
  const GetProfile = async () => {
    try {
      const res = await axios.get(`/Candidate/GetProfile?UID=${userUID}`);
      // console.log("candidatedata", res.data.responseData);
      setProfileData(res.data.responseData);
      const userData = res.data.responseData;
      localStorage.setItem("firstName", userData.firstName);
      localStorage.setItem("lastName", userData.lastName);
      localStorage.setItem("langName", userData.langName);
      localStorage.setItem("cityName", userData.cityName);
      localStorage.setItem("genderName", userData.genderName);
      localStorage.setItem("profilPic", userData.profileImage);
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    GetProfile();
  }, []);
  // console.log("res", profileData);

  useEffect(() => {
    if (profileData) {
      setGenderValue(profileData?.genderId);
      dispatch(selectGender(profileData?.genderId));
      setLangValue(profileData?.langId);
      setCitValue(profileData?.cityId);
      dispatch(selectCity(profileData?.cityId));
      setStartDate(profileData?.dob);
      setProfileImageview(profileData?.profileImage);
    }
  }, [profileData]);

  // ...............................Get PROFILE End.......................................
  return (
    <>
      <section className="account-section pt-1">
        <h6>Profile Setting</h6>
        <div className="profile-setting-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="Langauge">Language</label>
              {/* <select
                id="Langauge"
                className="form-control Dark-Input-from-group"
                placeholder="Gender"
                required
                onChange={(e) => setLangValue(e.target.value)}
                value={langValue}
                invalid={displays && langValue === ""}
              >
                <option value="">Select Language</option>
                <option value="1">Language1</option>
                <option value="2">Language2</option>
                <option value="3">Language3</option>
              </select> */}
              <ReactSelect
                options={LanguageList}
                onChange={handleLanguageSelect}
                value={
                  LanguageList.find(
                    (option) => option.value === langValue
                  ) || null
                }
                placeholder="Select Gender"
                styles={customStyles}
                classNamePrefix="react-select"
                className="form-control"
              />
              {displays && !langValue ? (
                <span className="error_msg_lbl text-red">Enter Language </span>
              ) : null}
            </div>

            <div className="form-group">
              <label htmlFor="dob">DOB</label>
              <Flatpickr
                id="dob"
                className="form-control Dark-Input-from-group"
                required
                // onChange={(e) => setStartDate(e.target.value)}
                onChange={(date) => setStartDate(date[0])}
                value={startDate}
                invalid={displays && startDate === ""}
              />

              {displays && !startDate ? (
                <span className="error_msg_lbl text-red">Enter Dob </span>
              ) : null}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="gender">Gender</label>
              <ReactSelect
                options={genderOptions}
                onChange={handleGenderSelect}
                value={
                  genderOptions.find(
                    (option) => option.value === genderValue
                  ) || null
                }
                placeholder="Select Gender"
                styles={customStyles}
                classNamePrefix="react-select"
                className="form-control"
              />
              {displays && !genderValue ? (
                <span className="error_msg_lbl text-red">Enter Gender </span>
              ) : null}
            </div>

            <div className="form-group">
              <label htmlFor="city">City</label>
              <ReactSelect
                options={cityList}
                onChange={handleCitySelect}
                value={
                  cityList.find((option) => option.value === cityId) ||
                  null
                }
                placeholder="Select city"
                styles={customStyles}
                classNamePrefix="react-select"
                className="form-control"
              />

              {displays && !cityId ? (
                <span className="error_msg_lbl text-red">Enter City </span>
              ) : null}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="lastName">Profile Image</label>
              <input
                type="file"
                id="lastName"
                className="form-control Dark-Input-from-group"
                placeholder=""
                required
                onChange={(e) => {
                  handleProfileImageChange(e);
                }}
                // value={profileImage}
                invalid={displays && profileImage === ""}
              />

              {displays && !profileImage ? (
                <span className="error_msg_lbl text-red">Enter Language </span>
              ) : null}
            </div>
            <div className="form-group">
              <img src={profileImageview} width={200} height={200} />
            </div>
          </div>

          <button className="btn btn-primary" onClick={(e) => Profile(e)}>
            Update
          </button>
        </div>
      </section>
    </>
  );
};

export default UpdateCandidateProfile;
